<template>
  <div v-if="visible" class="fixed z-20 w-screen h-screen wrapper">
    <div v-click-outside="close" class="content-wrapper" @click.stop>
      <div v-if="url">
        <div
          class="absolute w-3 h-3 md:w-4 md:h-4 top-4 right-4 md:top-8 md:right-8 cursor-pointer"
        >
          <img src="../assets/close.png" class="w-full h-full" alt="关闭" @click="close" />
        </div>
        <div class="img-wrapper overflow-y-auto w-full bg-white">
          <img :src="url" class="max-w-screen-md w-full" alt="" />
        </div>
        <div class="h-12 md:h-20 bg-white button-wrapper relative">
          <div class="save-button md:block hidden" @click="downloadFile(url, title || '问卷截图')">
            保存图片
          </div>
          <div class="save-button-mb">长按保存图片</div>
        </div>
      </div>
      <div
        v-else
        class="md:max-w-screen-md max-w-9/10 w-screen h-160 bg-white flex items-center rounded-md justify-center mx-auto"
      >
        <div>
          <SystemLoading class="w-24 mb-4 mx-auto" />
          <span class="text-gray-500">正在生成图片...</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import clickOutside from 'vue-click-outside';
import SystemLoading from '@/components/common/system-loading';
@Component({
  directives: {
    clickOutside
  },
  components: {
    SystemLoading
  }
})
export default class PreviewScreemshot extends Vue {
  @Prop({ type: String }) url: string;
  @Prop({ type: String }) title: string;
  @Prop({ type: Boolean }) visible: boolean;

  close() {
    this.$emit('update:visible', false);
    this.$emit('update:url', '');
  }

  downloadFile(content: string, fileName: string) {
    const base64ToBlob = (code: string) => {
      const parts = code.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {
        type: contentType
      });
    };
    const aLink = document.createElement('a');
    const blob = base64ToBlob(content);
    const evt = document.createEvent('HTMLEvents');
    aLink.download = fileName;
    aLink.href = URL.createObjectURL(blob);
    aLink.click();
  }
}
</script>
<style scoped>
.wrapper {
  background-color: rgba(0, 0, 0, 0.4);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}

.content-wrapper {
  @apply rounded-md overflow-hidden relative w-5/6 md:w-auto;
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 768px;
  min-height: 520px;
  transform: translate(-50%, -50%);
}

.img-wrapper {
  max-height: 80vh;
}

.button-wrapper {
  @apply flex items-center;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.1);
}

.save-button {
  @apply w-40 h-10 rounded-md mx-auto text-center cursor-pointer bg-motif hover:opacity-hover active:opacity-active;
  color: white;
  line-height: 2.5rem;
}

.save-button-mb {
  @apply md:hidden w-full h-full text-center text-white text-sm;
  line-height: 3rem;
  background: linear-gradient(246deg, rgba(83, 116, 229, 0.73) 0%, rgba(116, 80, 245, 0.73) 100%);
}
</style>
